import { render, staticRenderFns } from "./VideoAd.vue?vue&type=template&id=1896eef0&scoped=true"
import script from "./VideoAd.vue?vue&type=script&lang=js"
export * from "./VideoAd.vue?vue&type=script&lang=js"
import style0 from "./VideoAd.vue?vue&type=style&index=0&id=1896eef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1896eef0",
  null
  
)

export default component.exports